<script>
  export let totalChecked = 0;
  export let total = 100;
  export let text = "";
  export let collapseWhenComplete = false;
  export let useSlashSeparator = false;
  $: percentage = total ? Math.round((totalChecked / total) * 100) : 0;
  $: complete = total > 0 && totalChecked >= total;
</script>

<div class="groups_check">
  <div class="group_bar" style="width: {percentage}%"></div>
  <div class="info_text">
    {#if useSlashSeparator}
      <span>{totalChecked}</span>/<span>{total}</span>&nbsp;{text}
    {:else if collapseWhenComplete && complete}
      <span>{totalChecked}</span>&nbsp;{text}
    {:else}
      <span>{totalChecked}</span>&nbsp;of&nbsp;<span>{total}</span>&nbsp;{text}
    {/if}
  </div>
  <span class="percentage">{percentage}%</span>
</div>

<style>
  .groups_check {
    position: relative;
    width: auto;
    height: 2.375rem;
    flex-shrink: 0;
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 0.75rem;
    padding: 0 0.75rem;
    border-radius: 0.3125rem;
    background: #f2f2f2;
    overflow: hidden;
  }

  .group_bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #8ef095;
    border-radius: 0.3125rem;
    z-index: 0;
    transition: width 0.3s ease;
  }

  .info_text {
    z-index: 1;
    display: flex;
    align-items: center;
    color: var(--pax-black, #1c1c20);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    white-space: nowrap;
  }

  .info_text span {
    font-weight: 700;
  }

  .percentage {
    z-index: 1;
    color: var(--pax-black, #1c1c20);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
  }
</style>
